import { useEffect, useState } from "react";
import s from "./styles.module.scss";
import { Link } from "react-router-dom";
import { Data8Service } from "../../../services";

interface inputFieldTextProps {
  fieldName: string;
  saveValue: (obj: { field: string; value: string }) => {
    success: boolean;
    error: string;
  };
  submitValue?: any;
  fieldType?: string | null;
  populateValue?: string;
  enhanced?: boolean;
  required?: boolean;
  showErrors?: boolean;
}

export const InputFieldText = (props: inputFieldTextProps) => {
  const {
    fieldName,
    saveValue,
    fieldType,
    populateValue,
    enhanced = false,
    required = false,
    showErrors = false,
  } = props;
  const [valueToSave, setValueToSave] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (
      !valueToSave &&
      typeof populateValue != "undefined" &&
      populateValue !== ""
    ) {
      setValueToSave(populateValue);
    }
  }, [populateValue]);

  useEffect(() => {
    if (showErrors && required && !valueToSave.trim()) {
      setError("This field is required");
    } else {
      setError("");
    }
  }, [showErrors, required, valueToSave]);

  const onChangeFunc = async (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.currentTarget.value;
    setValueToSave(newValue);

    let toSave = { field: fieldName, value: newValue };
    const saveResult = saveValue(toSave);

    saveResult.success ? setError("") : setError(saveResult.error);
  };

  const onBlurFunc = async (e: React.FocusEvent<HTMLInputElement>) => {
    const newValue = e.currentTarget.value;
    if (newValue.trim()) {
      const isValid = await data8Validation(newValue);
      if (!isValid) {
        // Don't clear the value, just show the error
        return;
      }
    }
  };

  const data8Validation = async (newValue: string) => {
    if (
      typeof fieldType != "undefined" &&
      fieldType == "email" &&
      newValue.length > 0
    ) {
      // Only validate email if it looks like a complete email
      if (
        newValue.includes("@") &&
        newValue.includes(".") &&
        newValue.length > 5
      ) {
        const data8Valid = await Data8Service("EmailValidation", "IsValid", {
          email: newValue,
        });
        const res = data8Valid?.Result;
        const isInvalid =
          res === "Invalid" ||
          res?.ValidationResult === "Invalid" ||
          res?.IsValid === false;
        if (isInvalid) {
          setError("Invalid email");
          return false;
        }
      }
    }
    if (
      typeof fieldType != "undefined" &&
      fieldType == "tel" &&
      newValue.length > 0
    ) {
      // Only validate phone if it looks like a complete UK phone number
      if (newValue.length >= 10 && newValue.length <= 15) {
        const data8Valid = await Data8Service("PhoneValidation", "IsValid", {
          telephoneNumber: newValue,
          defaultCountry: "GB",
        });
        const res = data8Valid?.Result;
        const isInvalid =
          res === "Invalid" ||
          res?.ValidationResult === "Invalid" ||
          res?.IsValid === false;
        if (isInvalid) {
          setError("Invalid telephone number");
          return false;
        }
      }
    }
    return true;
  };

  return (
    <>
      <div className={s.inputWrapper}>
        <input
          className={`${s.inputStyle} ${
            fieldName == "registration" ? s.uppercase : ""
          } ${enhanced ? s.enhanced : ""} ${error ? s.error : ""}`}
          type={`${fieldType != null ? fieldType : "text"}`}
          name={fieldName}
          value={valueToSave}
          onChange={onChangeFunc}
          onBlur={onBlurFunc}
          required={required}
        />
      </div>
      <span
        className={s.notice}
        style={{
          opacity: error ? 1 : 0,
          pointerEvents: error ? "auto" : "none",
        }}
      >
        {error || ""}
      </span>
    </>
  );
};
